import { render, staticRenderFns } from "./dialog_release.vue?vue&type=template&id=c193810e&scoped=true&"
import script from "./dialog_release.vue?vue&type=script&lang=js&"
export * from "./dialog_release.vue?vue&type=script&lang=js&"
import style0 from "./dialog_release.vue?vue&type=style&index=0&id=c193810e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c193810e",
  null
  
)

export default component.exports